import "../App.css";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";

function Info() {
  const TFCBT_URL = process.env.REACT_APP_TFCBT_URL || 'http://localhost:3004';
  return (
    <Accordion className="home-accordion px-5 mb-5">
      <Accordion.Item eventKey="0">
        <Accordion.Header className="item-header">Who is this for?</Accordion.Header>
        <Accordion.Body className="item-body">
          This course is primarily for licensed psychotherapy providers but is open to those who hold a master's or doctorate in a clinical mental health discipline or students currently enrolled in such a graduate degree program. Completion of <a href="https://tfcbt2.musc.edu/" target="_blank" rel="noopener noreferrer" >TF-CBTWeb2.0</a> is a prerequisite to take CTGWeb2.0.
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header className="item-header">What will I learn?</Accordion.Header>
        <Accordion.Body className="item-body">
          CTGWeb2.0 teaches the application of <a href="https://tfcbt.org/" target="_blank" rel="noopener noreferrer">Trauma-Focused Cognitive Behavioral Therapy</a> (TF-CBT) principles and methods in cases where a child or adolescent has experienced the unexpected/traumatic death of an important person resulting in symptoms of PTSD, depression, grief, and/or behavior problems. The course consists of six modules, including a foundational introduction and the five core GRIEF components:
          <ul>
            <br/>
            <li>Applying TF-CBT to CTG</li>
            <li>Grief Psychoeducation</li>
            <li>Resolving Ambivalent Feelings</li>
            <li>Incorporating Positive Memories</li>
            <li>Enhancing Positive Relationships</li>
            <li>Finishing Treatment & Graduation</li>
          </ul>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header className="item-header">Can I earn continuing education credit?</Accordion.Header>
        <Accordion.Body className="item-body">
          Learners who complete all 6 modules of CTGWeb2.0 may earn up to 6 hours of continuing education credit depending on their profession and their state board’s recognition of the course’s approvers. For more information about continuing education approvals, please see the course <Link to="/ceustatement" target="_blank">CEU Statement</Link>.
        </Accordion.Body>
      </Accordion.Item>
      {/* <Accordion.Item eventKey="3"> <--- Update all subsequent eventKey attributes if Jerry wants this added back in
        <Accordion.Header className="item-header">How do I register multiple learners?</Accordion.Header>
        <Accordion.Body className="item-body">
          Organizations that have registered a Purchasing Administrator account in TF-CBTWeb2.0 may also purchase multiple registrations for CTGWeb2.0 in a single online transaction or request an invoice for payment by check. With online purchases, all learners specified in a purchase receive an email containing a unique link to activate a course account. Accounts purchased by organizations that have not been activated may be transferred to another learner.<br /><br />
          <a href={`${TFCBT_URL}/en/users/sign_up`} target="_blank" rel="noopener noreferrer" >Register a TF-CBTWeb2.0 Purchasing Administrator Account</a>
        </Accordion.Body>
      </Accordion.Item> */}
      <Accordion.Item eventKey="3">
        <Accordion.Header className="item-header">Who created this course?</Accordion.Header>
        <Accordion.Body className="item-body">
          CTGWeb2.0 represents the joint effort and contributions of many people coordinated by the Course Director, Daniel W. Smith, Ph.D. in collaboration with and as authorized by the developers of the TF-CBT treatment model. These contributors are detailed on the course <a href="/about" target="_blank" rel="noopener noreferrer">About</a> page.
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default Info;
